import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import NovaLayout from "@/components/NovaLayout";
import Layout from "@/components/Layout";
import HomeC from "@/pages/HomeC";
import Home from "@/pages/Home";
import HomeAlt from "@/pages/HomeAlt";
import Services from "@/pages/Services";
import ServiceFamily from "@/pages/ServiceFamily";
import Region from "@/pages/Region";
import Solutions from "@/pages/Solutions";
import SolutionsBusinesses from "@/pages/SolutionsBusinesses";
import SolutionsAccountants from "@/pages/SolutionsAccountants";
import SolutionsFinancial from "@/pages/SolutionsFinancial";
import Platform from "@/pages/Platform";
import Resources from "@/pages/Resources";
import ResourceArticle from "@/pages/ResourceArticle";
import Partners from "@/pages/Partners";
import ApiDocs from "@/pages/ApiDocs";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import AdminLeads from "@/pages/AdminLeads";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Theme C "Nova" — primary site experience */}
          <Route element={<NovaLayout />}>
            <Route path="/" element={<HomeC />} />
            <Route path="/theme-c" element={<HomeC />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceFamily />} />
            <Route path="/regions/:slug" element={<Region />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/businesses" element={<SolutionsBusinesses />} />
            <Route path="/solutions/accountants" element={<SolutionsAccountants />} />
            <Route path="/solutions/financial-institutions" element={<SolutionsFinancial />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<ResourceArticle />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/api-docs" element={<ApiDocs />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          {/* Archived theme previews */}
          <Route path="/theme-a" element={<Layout />}>
            <Route index element={<Home />} />
          </Route>
          <Route path="/theme-b" element={<HomeAlt />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
